import get from 'lodash/get';
import featureFlags from '@/store/modules/featureFlags';
import Pulse from './Pulse.vue';
import Now from './Now/Now.vue';
import Today from './Today/Today.vue';
import Selections from './Insights/Selections.vue';
import Pulse365 from './365/Pulse365.vue';

const showPulseSelections = get(featureFlags, 'state.FEATURE_FLAGS.PULSE_SELECTIONS', false);
const showPulse365 = get(featureFlags, 'state.FEATURE_FLAGS.PULSE_365', false);

const rootRoute = {
  path: '/pulse',
  name: 'Pulse',
  component: Pulse,
  meta: {
    auth: true,
  },
  props: {
    baseResource: '/pulse',
  },
};

const commonChildMeta = {
  auth: true,
  resource: rootRoute.path,
  parentName: rootRoute.name,
};

const childRoutes = [
  {
    path: 'now',
    name: 'Pulse.Now',
    component: Now,
    meta: {
      label: 'Now',
      ...commonChildMeta,
    },
  },
  {
    path: 'today',
    name: 'Pulse.Today',
    component: Today,
    meta: {
      label: 'Today',
      ...commonChildMeta,
    },
  },
];

if (showPulseSelections) childRoutes.push({
  path: 'insights',
  name: 'Pulse.Insights',
  component: Selections,
  meta: {
    label: 'Insights',
    ...commonChildMeta,
  },
});

if (showPulse365) {
  childRoutes.push({
    path: 'pulse365',
    name: 'Pulse.365',
    component: Pulse365,
    meta: {
      label: '365',
      ...commonChildMeta,
    },
  });
}

rootRoute.props.children = childRoutes;

export default {
  ...rootRoute,
  children: childRoutes,
};
